import {
    apiRequest,
    periodeVerifikasiDetail
} from "../../../../../services/adapters/kepegawaian/periodeVerifikasiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", periodeVerifikasiDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository